@if (isPopupOpen) {
  <div class="popup-overlay">
    <div class="popup-container">
      <!-- Fixed Header -->
      <div class="popup-header">
        <input
          #searchInput
          type="text"
          class="search-input"
          [value]="searchValue"
          (focus)="scrollToInput()"
          (input)="onBrowserSearch($event)"
          placeholder="Search..."
          autofocus
          />
          <button class="close-button" (click)="closePopup()">✕</button>
        </div>
        <!-- Scrollable Results -->
        <div class="results-container">
          @if (!isSearchEmpty()) {
            <ul>
              @for (category of searchProductList | keyvalue; track category) {
                <li>
                  @if (category.value.length > 0) {
                    <div>
                      <h3>{{ getCategoryDesc(category.key) | translate }}</h3>
                      <ul>
                        @for (item of category.value; track item) {
                          <li
                            class="card-item"
                            (click)="onclick($event, item)"
                            >
                            <div style="width: 100px; height: 50px">
                              <img
                                [src]="item.images![0].image"
                                alt="{{ item.name }}"
                                class="profile-image"
                                />
                              </div>
                              <div class="card-content">
                                <div class="name">{{ item.name }}</div>
                                <div class="location">{{ item.description }}</div>
                              </div>
                              <div class="status-dot" [ngClass]="getStatusColor(item.status)"></div>
                            </li>
                          }
                        </ul>
                      </div>
                    }
                  </li>
                }
              </ul>
            } @else {
              <div class="no-results">
                @if (searchProductList?.length ==0 && !inProgress) {
                  <p>No results found.</p>
                }
                @if (searchValue.length == 0) {
                  <p>Start typing to search...</p>
                }
              </div>
            }
            <!-- Empty or no search results -->
          </div>
        </div>
      </div>
    }
